<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2022-11-14 14:22:43
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-09-18 10:37:42
 * @FilePath: /wemeet-admin-new/src/views/dragger/template/tpl_flex_three.vue
 * @Description: 
 * Copyright (c) 2024 by WeMeet, All Rights Reserved. 
-->
<template>
  <div class="layout">
    <div class="view-height-flexThree">
      <img
        v-if="!res.list[0].extraParams || !res.list[0].extraParams.isVideo"
        alt
        class="image-mode"
        :src="res.list[0].img"
      />
      <video v-else controls :src="res.list[0].extraParams.videoSrc" style="width: 100%; height: 100%"></video>
    </div>
    <div class="view-height-flexThree">
      <img
        v-if="!res.list[1].extraParams || !res.list[1].extraParams.isVideo"
        alt
        class="image-mode"
        :src="res.list[1].img"
      />
      <video v-else controls :src="res.list[1].extraParams.videoSrc" style="width: 100%; height: 100%"></video>
    </div>
    <div class="view-height-flexThree">
      <img
        v-if="!res.list[2].extraParams || !res.list[2].extraParams.isVideo"
        alt
        class="image-mode"
        :src="res.list[2].img"
      />
      <video v-else controls :src="res.list[2].extraParams.videoSrc" style="width: 100%; height: 100%"></video>
    </div>
  </div>
</template>

<script>
  export default {
    title: '三列单行图片模块',
    props: ['res'],
  }
</script>
<style lang="scss" scoped>
  @import './tpl.scss';
  .layout {
    display: flex;
    align-items: center;
    justify-content: center;
    background-size: cover;
    box-sizing: border-box;
  }
</style>
